import React, {useEffect, useState} from "react"
import MetaTags from "react-meta-tags"
import {Container, Card, CardBody, Nav, NavItem, NavLink} from "reactstrap"
import classnames from "classnames"
import {withRouter} from "react-router"
import DataTableUser from "./DataTableUser"
import AddUser from "./AddUser"
import CloturerBaseDonnee from "./CloturerBaseDonnee";

const User = props => {
    const [section, setSection] = useState(1)
    const [add, setAdd] = useState(0);
    const [cloture, setCloture] = useState(0);
    useEffect(async () => {
        var cloture_annee = JSON.parse(localStorage.getItem("cloture"));
        setCloture(cloture_annee)
        const userAuth = JSON.parse(localStorage.getItem('UserMenu'));
        const typeArticleSubMenu = userAuth.find(user =>
            user.sous_menu.some(subMenu => subMenu.sous_menu === "Gestion Utilisateur")
        );
        setAdd(typeArticleSubMenu.sous_menu[0].add)
    }, [])
    var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
    var role_id = userAuthScolarite.user.role_id
    const back = () => {
        setSection(1)
    }

    const renderBlock = section => {
        if (section === 1) {
            return <DataTableUser/>
        } else if (section === 2) {
            return <AddUser back={back} setSection={setSection}/>
        } else if (section === 3) {
            return <CloturerBaseDonnee back={back} setSection={setSection}/>
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Utilisateur | Cresus </title>
                </MetaTags>
                <Container fluid>
                    <div>
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    style={{cursor: "pointer"}}
                                    className={classnames({
                                        active: section === 1,
                                    })}
                                    onClick={() => {
                                        setSection(1)
                                    }}
                                >
                                    Utilisateur
                                </NavLink>
                            </NavItem>
                            {cloture != 1 ? (
                                add === 1 ? (
                                    <NavItem>
                                        <NavLink
                                            style={{cursor: "pointer"}}
                                            className={classnames({
                                                active: section === 2,
                                            })}
                                            onClick={() => {
                                                setSection(2)
                                            }}
                                        >
                                            Ajouter utilisateur
                                        </NavLink>
                                    </NavItem>
                                ) : (null)
                            ) : (null)}
                            {role_id === 1 ? (
                                <NavItem>
                                    <NavLink
                                        style={{cursor: "pointer"}}
                                        className={classnames({
                                            active: section === 3,
                                        })}
                                        onClick={() => {
                                            setSection(3)
                                        }}
                                    >
                                        {"Clôturer cette l'année"}
                                    </NavLink>
                                </NavItem>
                            ) : (null)}
                        </Nav>
                        <Card>
                            <CardBody>{renderBlock(section)}</CardBody>
                        </Card>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(User)
